export default __webpack_public_path__ + "static/media/confirmed_1.d7fe6280.svg";